import { FC, useEffect } from 'react';

import { css, Global } from '@emotion/react';
import styled from '@emotion/styled';

import SplashLogoSvg from './splash-logo.svg';

const Container = styled.div`
  position: relative;
  aspect-ratio: 118/16;
  color: ${({ theme }) => theme.color.onInverseSurface};
`;

const Faded = styled(SplashLogoSvg)`
  opacity: ${({ theme }) => theme.opacity.faded};
`;

const LoadingContainer = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  bottom: 0;
  right: var(--splash-screen-percentage);
  overflow: hidden;
`;

export const SplashLogo: FC<{
  width: number;
  loading: number;
  className?: string;
}> = ({ width, loading, className }) => {
  useEffect(() => {
    document.body.style.setProperty(
      '--splash-screen-percentage',
      (100 - loading).toString() + '%',
    );
  }, [loading]);

  return (
    <>
      <Global
        styles={css`
          body {
            --splash-screen-percentage: 100%;
          }
        `}
      />
      <Container className={className} style={{ width }}>
        <Faded style={{ width, height: 'auto' }} />
        <LoadingContainer>
          <SplashLogoSvg style={{ width, height: 'auto' }} />
        </LoadingContainer>
      </Container>
    </>
  );
};
